// FILE: src/components/FocusAreasCard.js
//
// Up to 3 weakest phases with horizontal bars. Color = accuracy band:
// red <60, amber 60-74, brand 75+. Tap → readiness detail.

import React from 'react';
import styles from './FocusAreasCard.module.css';

export default function FocusAreasCard({ weakPhases = [], onViewDetails }) {
  const top = (weakPhases || []).slice(0, 3);
  if (top.length === 0) {
    return (
      <div className={styles.card} data-testid="dashboard-focus-areas">
        <div className={styles.head}>◎ Focus Areas</div>
        <div className={styles.empty}>No clear weak phase yet — keep practicing across all domains.</div>
      </div>
    );
  }

  return (
    <div className={styles.card} data-testid="dashboard-focus-areas">
      <div className={styles.head}>◎ Focus Areas</div>
      <div className={styles.list}>
        {top.map((w) => {
          const acc = Math.round(w.accuracy || 0);
          return (
            <div key={w.phase} className={styles.row}>
              <div className={styles.rowHead}>
                <span className={styles.name}>{w.phase}</span>
                <span className={pctClass(acc, styles)}>{acc}%</span>
              </div>
              <div className={styles.bar}>
                <span
                  className={barClass(acc, styles)}
                  style={{ width: `${Math.max(2, acc)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {onViewDetails && (
        <button type="button" className={styles.link} onClick={onViewDetails}>
          View details ›
        </button>
      )}
    </div>
  );
}

function pctClass(v, styles) {
  if (v < 60) return styles.pctBad;
  if (v < 75) return styles.pctWarn;
  return styles.pctOk;
}
function barClass(v, styles) {
  if (v < 60) return styles.barBad;
  if (v < 75) return styles.barWarn;
  return styles.barOk;
}
